import { ContainerItem, Item, Price } from '@/features/orders/types/app'
import currencyJs from 'currency.js'
import invariant from 'tiny-invariant'

export const ItemsPriceCalculator = {
    calculateTotalPrice: (items: Item[], currency: string): Price => {
        let price = currencyJs(0)

        items.forEach((item) => {
            invariant(currency === item.price.currency, 'Currencies mismatch')

            price = price.add(ItemsPriceCalculator.calculateTotalPriceForItem(item).amount)
        })

        return { amount: price.toString(), currency: currency }
    },

    calculateItemPriceWithoutExtras: (price: Price, quantity: number): Price => {
        const finalPrice = currencyJs(price.amount).multiply(quantity)

        return { amount: finalPrice.toString(), currency: price.currency }
    },

    calculateTotalContainerPrice: (
        items: Item[],
        containerItems: ContainerItem[],
        currency: string
    ): Price => {
        let price = currencyJs(0)

        items.forEach((item) => {
            if (item.container) {
                invariant(item.container.price.currency === currency, 'Currencies mismatch')

                price = price.add(currencyJs(item.container.price.amount).multiply(item.quantity))
            }

            item.addedItems?.forEach((addedItem) => {
                if (!addedItem.container) return

                invariant(addedItem.container.price.currency === currency, 'Currencies mismatch')

                price = price.add(
                    currencyJs(addedItem.container.price.amount).multiply(addedItem.quantity)
                )
            })
        })

        containerItems.forEach((containerItem) => {
            invariant(containerItem.price.currency === currency, 'Currencies mismatch')

            price = price.add(
                currencyJs(containerItem.price.amount).multiply(containerItem.quantity)
            )
        })

        return { amount: price.toString(), currency }
    },

    calculateTotalPriceForItem: (item: Item): Price => {
        const currency = item.price.currency

        let price = currencyJs(
            ItemsPriceCalculator.calculateItemPriceWithoutExtras(item.price, item.quantity).amount
        )

        item.toppings?.forEach((topping) => {
            invariant(topping.price.currency === currency, 'Currencies mismatch')

            price = price.add(
                currencyJs(topping.price.amount).multiply(topping.quantity).multiply(item.quantity)
            )
        })

        item.addedItems?.forEach((addedItem) => {
            invariant(addedItem.price.currency === currency, 'Currencies mismatch')

            price = price.add(currencyJs(addedItem.price.amount).multiply(addedItem.quantity))
        })

        return { amount: price.toString(), currency: currency }
    },
}
